import { render, staticRenderFns } from "./LoginKYC.vue?vue&type=template&id=eb3bbae0&scoped=true"
import script from "./LoginKYC.vue?vue&type=script&lang=ts"
export * from "./LoginKYC.vue?vue&type=script&lang=ts"
import style0 from "./LoginKYC.vue?vue&type=style&index=0&id=eb3bbae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3bbae0",
  null
  
)

export default component.exports